import { Component, OnInit } from '@angular/core';
import { FormBuilderBasicInputComponentModel } from '../../models/form-builder-basic-input-component-model';

@Component({
  selector: 'tf-core-fb-basic-input-section-input',
  templateUrl: './fb-basic-input-section-input.component.html',
  styleUrls: ['./fb-basic-input-section-input.component.css']
})
export class FbCoreBasicInputSectionInputComponent extends FormBuilderBasicInputComponentModel implements OnInit {
    public data = {
        component: null,
        hasChanges: false
    };

    constructor() {
        super();
    }

    ngOnInit(): void {
        super.init();
    }
}
